// extracted by mini-css-extract-plugin
export default {"slide_wrapper":"carousel-slider_slide_wrapper__fbNcO"};